import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { LoadingStatus } from '../../../../tokens-and-interfaces';

@Component({
  selector: 'crm-form-loading-indicator',
  template: `
    <ng-container *ngIf="loadingStatus === LoadingStatus.OK; else loadingState">
      <ng-content select="[form-content]"></ng-content>
    </ng-container>
    <ng-template #loadingState>
      <ng-container *ngIf="loadingStatus === LoadingStatus.LOADING">
        <glxy-loading-spinner></glxy-loading-spinner>
      </ng-container>

      <glxy-empty-state *ngIf="loadingStatus === LoadingStatus.ERROR">
        <glxy-empty-state-hero>
          <mat-icon>report_problem</mat-icon>
        </glxy-empty-state-hero>
        <glxy-empty-state-title>
          {{ 'MODEL_DRIVEN_FORM.LOADING_STATUS_ERROR.TITLE' | translate }}
        </glxy-empty-state-title>
        <p>{{ 'MODEL_DRIVEN_FORM.LOADING_STATUS_ERROR.TEXT' | translate }}</p>
        <glxy-empty-state-actions></glxy-empty-state-actions>
      </glxy-empty-state>
    </ng-template>
  `,
  styleUrls: [],
  standalone: true,
  imports: [CommonModule, TranslateModule, GalaxyEmptyStateModule, MatIconModule, GalaxyLoadingSpinnerModule],
})
export class CrmFormLoadingIndicatorComponent {
  @Input() loadingStatus!: LoadingStatus;
  LoadingStatus = LoadingStatus;
}
